import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { MultiSelectSidebarAction } from './multiSelectSidebar.action';
import { multiSelectSidebarInitialState } from './multiSelectSidebar.constant';
import { IMultiSelectSidebarStore, MultiSelectSidebarMode } from './multiSelectSidebar.interface';

export const multiSelectSidebarReducer = reducerWithInitialState(multiSelectSidebarInitialState)
  .case(MultiSelectSidebarAction.toggleMultiEditMode, (state): IMultiSelectSidebarStore => {
    const nextIsMultiEditMode = !state.isMultiEditMode;

    if (nextIsMultiEditMode) {
      return { ...state, isMultiEditMode: true };
    }

    return multiSelectSidebarInitialState;
  })
  .case(MultiSelectSidebarAction.setSelection, (state, { ids, rows }): IMultiSelectSidebarStore => {
    return { ...state, selectedIds: ids, selectedRows: rows };
  })
  .case(MultiSelectSidebarAction.clearSelection, (state): IMultiSelectSidebarStore => {
    return { ...state, selectedIds: [], selectedRows: [] };
  })
  .case(MultiSelectSidebarAction.openBulkEditSidebar, (state): IMultiSelectSidebarStore => {
    return { ...state, mode: MultiSelectSidebarMode.BulkEdit };
  })
  .case(MultiSelectSidebarAction.closeBulkEditSidebar, (state): IMultiSelectSidebarStore => {
    return { ...state, mode: MultiSelectSidebarMode.None };
  })
  .case(MultiSelectSidebarAction.destroy, () => {
    return multiSelectSidebarInitialState;
  });
